function buildSibDabuUrl(placementId) {
  const { placementIdx = 0, kwCount = 5 } = this.adPlacements[placementId] || {};
  const {
    dabuWidth, dabuHeight, dabuCategory, kwSource: dataKwSource, sibTemplate,
  } = this.dataset;

  if (sibTemplate) {
    return `${this.dabuUrl}/api/v1/preview/blocks/${sibTemplate}`;
  }

  const {
    terms, category, title, kwSource: paramKwSource,
  } = this.pageParams;
  const { campaignID } = this;
  const finalCategory = category || dabuCategory;
  const kwSource = paramKwSource || dataKwSource;

  const dabuUrl = new URL(`${this.dabuUrl}/api/v1/blocks`);
  dabuUrl.searchParams.set('cid', campaignID);
  dabuUrl.searchParams.set('sessionId', this.pvId);
  dabuUrl.searchParams.set('h', dabuHeight);
  dabuUrl.searchParams.set('w', dabuWidth);
  dabuUrl.searchParams.set('placementIdx', placementIdx);
  dabuUrl.searchParams.set('kwCount', kwCount);

  if (this.sourceUrl) {
    dabuUrl.searchParams.set('surl', this.sourceUrl);
  }

  if (terms) {
    dabuUrl.searchParams.set('terms', terms);
  }

  if (kwSource) {
    dabuUrl.searchParams.set('kwSource', kwSource);
  }

  let finalURL = dabuUrl.toString();

  // adding category and title this way since URIComponent encoded method is required in sibk
  if (finalCategory) {
    finalURL += `&category=${encodeURIComponent(finalCategory)}`;
  }

  if (title) {
    finalURL += `&title=${encodeURIComponent(title)}`;
  }

  // resolve params from page
  // only includs monetization params
  const monetizeParams = Object.keys(this.pageParams).map((key) => (this.monetizationParamsList.includes(key) ? `&${key}=${this.pageParams[key]}` : ''));

  finalURL += monetizeParams.join('');

  return finalURL;
}

async function getSibLinks(placementId) {
  const dabuUrl = this.buildSibDabuUrl(placementId);

  try {
    let dabuRes;
    try {
      dabuRes = await this.callDabu(dabuUrl);
      this.adContext.abTestBingTypeTag = dabuRes.bingTypeTag;
      this.adContext.googleClientId = dabuRes.pubId;
    } catch (dabuErr) {
      dabuRes = this.handleFailOver();
    }

    this.partner = dabuRes.partner.toLowerCase();
    this.mountDabuResponse(dabuRes, placementId);
  } catch (err) {
    // do nothing for bing search ads
    this.logger.error('error calling dabu', err);
  }
}

function getUnmountedPlacements() {
  return Object.values(this.adPlacements).filter((placement) => !placement.isMounted);
}

function mountSibsToTargetNodes() {
  const unmountedPlacements = this.getUnmountedPlacements();

  let numUnmountablePlacements = 0;
  for (let i = 0; i < unmountedPlacements.length; i++) {
    const p = unmountedPlacements[i];

    try {
      this.getSibLinks(p.placementId);
      p.setMountedFlag();
    } catch (err) {
      numUnmountablePlacements++;
      this.logger.error('unable to mount SIB', err);
    }
  }

  if (numUnmountablePlacements) {
    this.enqueuePollingfn(this.mountSibsToTargetNodes);
  }
}

export {
  buildSibDabuUrl, getUnmountedPlacements, getSibLinks, mountSibsToTargetNodes,
};
